import { Directive, HostBinding, HostListener, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PhoneDialogComponent } from '../dialogs/phone/phone.dialog';
import { validate_phone_number } from '../tools/phone-number';

/** Pair with the phone pipe on displayed numbers; never apply to inputs. */
@Directive({ selector: '[apPhone]' })
export class PhoneDirective {
  @Input() apPhone: string | null | undefined;

  constructor(private dialog: MatDialog) {}

  @HostBinding('attr.role') get role() { return this.enabled ? 'button' : null; }
  @HostBinding('attr.tabindex') get tabIndex() { return this.enabled ? 0 : null; }
  @HostBinding('class.ap-phone-link') get phoneLink() { return this.enabled; }
  @HostBinding('style.cursor') get cursor() { return this.enabled ? 'pointer' : null; }
  @HostBinding('attr.aria-label') get label() {
    return this.enabled ? `Show Call and SMS QR codes for ${this.apPhone}` : null;
  }

  private get enabled(): boolean { return validate_phone_number(this.apPhone); }

  @HostListener('click', ['$event'])
  open(event: Event): void {
    // Keep phone clicks from selecting the surrounding customer or opening a row.
    event.preventDefault();
    event.stopPropagation();
    if (!this.enabled) return;
    this.dialog.open(PhoneDialogComponent, {
      data: this.apPhone, width: '560px', maxWidth: '95vw'
    });
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') this.open(event);
  }
}
